import type { AppMode } from "@/types/embed";

function bool(value: string | undefined, fallback: boolean): boolean {
  if (value == null || value === "") return fallback;
  return value === "true" || value === "1" || value === "yes";
}

const isDev = import.meta.env.DEV;

export const env = {
  apiBaseUrl:
    import.meta.env.VITE_API_BASE_URL?.trim() ||
    (isDev ? "http://localhost:7071/api" : "/api"),
  appMode: (import.meta.env.VITE_APP_MODE?.trim() as AppMode) || "standalone",
  environment: import.meta.env.VITE_ENVIRONMENT?.trim() || (isDev ? "local" : "prod"),
  // Mock off by default; set VITE_USE_MOCK_API=true for offline UI demos.
  useMockApi: bool(import.meta.env.VITE_USE_MOCK_API, false),
  // Local dev skips direct-to-blob PUT (storage CORS); prod uses SAS with BFF fallback.
  uploadViaBff: bool(import.meta.env.VITE_UPLOAD_VIA_BFF, isDev),
  // When unset/empty, "/" shows an offer picker instead of redirecting.
  defaultOfferId: import.meta.env.VITE_DEFAULT_OFFER_ID?.trim() || undefined,
  isDev,
} as const;
